module.exports = __webpack_public_path__ + "img/Battery3.85130eb3.svg";